let wsDebugEnabled: boolean | null = null;

function computeWsDebugEnabled() {
  if (process.env.NEXT_PUBLIC_WS_DEBUG === "true") {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  try {
    const query = new URLSearchParams(window.location.search);
    const queryValue = query.get("wsdebug");
    if (queryValue === "1" || queryValue === "true") {
      return true;
    }
  } catch (error) {
    // Ignore URL parsing errors and continue with other checks.
  }

  try {
    const localStorageValue = window.localStorage.getItem("ws_debug");
    if (localStorageValue === "1" || localStorageValue === "true") {
      return true;
    }
  } catch (error) {
    // Ignore storage access errors and fallback to disabled.
  }

  return false;
}

export function isWsDebugEnabled() {
  if (wsDebugEnabled == null) {
    wsDebugEnabled = computeWsDebugEnabled();
  }

  return wsDebugEnabled;
}

export function wsDebug(event: string, payload?: unknown) {
  if (!isWsDebugEnabled()) {
    return;
  }

  const time = new Date().toISOString();
  if (payload === undefined) {
    console.log(`[ws-debug ${time}] ${event}`);
    return;
  }

  console.log(`[ws-debug ${time}] ${event}`, payload);
}
